import React from 'react';
import { ArrowUturnLeftIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../hooks/useAuth';

export const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonationMeta, endImpersonation } = useAuth() as any;

  if (!isImpersonating) return null;

  return (
    <div className="sticky top-0 z-50 border-b border-amber-300 bg-gradient-to-r from-amber-100 via-amber-50 to-orange-100 px-4 py-2.5 text-amber-950 shadow-sm">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2">
          <UserCircleIcon className="h-5 w-5 shrink-0 text-amber-700" aria-hidden />
          <p className="truncate text-sm font-medium">
            Modo soporte activo en <span className="font-semibold">{impersonationMeta?.tenantName}</span>{' '}
            ({impersonationMeta?.tenantSlug})
          </p>
        </div>
        <button
          type="button"
          onClick={() => endImpersonation()}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-amber-700/25 bg-white/70 px-3 py-1.5 text-xs font-semibold text-amber-900 transition-colors hover:bg-white"
        >
          <ArrowUturnLeftIcon className="h-4 w-4" aria-hidden />
          Salir de soporte
        </button>
      </div>
    </div>
  );
};
